[
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/RoleDto.schema.json",
    "fileMatch": ["a://b/RoleDto*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/RoleDto.schema.json",
      "title": "RoleDto",
      "type": "object",
      "properties": {
        "role": {
          "enum": [
            "presentation:manage",
            "presentation:request",
            "issuance:manage",
            "issuance:offer",
            "clients:manage",
            "tenants:manage",
            "registrar:manage"
          ],
          "type": "string",
          "description": "OAuth2 roles",
          "example": "issuance:manage"
        }
      },
      "required": ["role"]
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/ClientCredentialsDto.schema.json",
    "fileMatch": ["a://b/ClientCredentialsDto*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/ClientCredentialsDto.schema.json",
      "title": "ClientCredentialsDto",
      "type": "object",
      "properties": {
        "grant_type": {
          "type": "string",
          "default": "client_credentials"
        },
        "client_id": {
          "type": "string"
        },
        "client_secret": {
          "type": "string"
        }
      },
      "required": ["client_id", "client_secret"]
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/TokenResponse.schema.json",
    "fileMatch": ["a://b/TokenResponse*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/TokenResponse.schema.json",
      "title": "TokenResponse",
      "type": "object",
      "properties": {
        "access_token": {
          "type": "string"
        },
        "refresh_token": {
          "type": "string"
        },
        "token_type": {
          "type": "string"
        },
        "expires_in": {
          "type": "number"
        }
      },
      "required": ["access_token", "token_type", "expires_in"]
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/ImportTenantDto.schema.json",
    "fileMatch": ["a://b/ImportTenantDto*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/ImportTenantDto.schema.json",
      "title": "ImportTenantDto",
      "type": "object",
      "properties": {
        "name": {
          "type": "string",
          "description": "The name of the tenant."
        },
        "description": {
          "type": "string",
          "description": "The description of the tenant."
        }
      },
      "required": ["name"]
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/SessionStorageConfig.schema.json",
    "fileMatch": ["a://b/SessionStorageConfig*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/SessionStorageConfig.schema.json",
      "title": "SessionStorageConfig",
      "type": "object",
      "properties": {
        "ttlSeconds": {
          "type": "number",
          "description": "Time-to-live for sessions in seconds. If not set, uses global SESSION_TTL.",
          "example": 86400,
          "minimum": 60
        },
        "cleanupMode": {
          "type": "string",
          "description": "Cleanup mode: 'full' deletes everything, 'anonymize' keeps metadata but removes PII.",
          "enum": ["full", "anonymize"],
          "default": "full"
        }
      }
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/StatusListConfig.schema.json",
    "fileMatch": ["a://b/StatusListConfig*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/StatusListConfig.schema.json",
      "title": "StatusListConfig",
      "type": "object",
      "properties": {
        "capacity": {
          "type": "number",
          "description": "The capacity of the status list. If not set, uses global STATUS_CAPACITY.",
          "example": 10000,
          "minimum": 100
        },
        "bits": {
          "type": "number",
          "description": "Bits per status entry: 1 (valid/revoked), 2 (with suspended), 4/8 (extended). If not set, uses global STATUS_BITS.",
          "enum": [1, 2, 4, 8],
          "default": 1
        },
        "ttl": {
          "type": "number",
          "description": "TTL in seconds for the status list JWT. If not set, uses global STATUS_TTL.",
          "example": 3600,
          "minimum": 60
        },
        "immediateUpdate": {
          "type": "boolean",
          "description": "If true, regenerate JWT immediately on status changes. If false (default), use lazy regeneration on TTL expiry.",
          "default": false
        },
        "enableAggregation": {
          "type": "boolean",
          "description": "If true, include aggregation_uri in status list JWTs for pre-fetching support (default: true).",
          "default": true
        }
      }
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/TenantEntity.schema.json",
    "fileMatch": ["a://b/TenantEntity*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/TenantEntity.schema.json",
      "title": "TenantEntity",
      "type": "object",
      "properties": {
        "sessionConfig": {
          "nullable": true,
          "description": "Session storage configuration for this tenant. Controls TTL and cleanup behavior.",
          "allOf": [
            {
              "$ref": "./SessionStorageConfig.schema.json"
            }
          ]
        },
        "statusListConfig": {
          "nullable": true,
          "description": "Status list configuration for this tenant. Only affects newly created status lists.",
          "allOf": [
            {
              "$ref": "./StatusListConfig.schema.json"
            }
          ]
        },
        "id": {
          "type": "string",
          "description": "The unique identifier for the tenant."
        },
        "name": {
          "type": "string",
          "description": "The name of the tenant."
        },
        "description": {
          "type": "string",
          "description": "The description of the tenant."
        },
        "status": {
          "type": "string",
          "description": "The current status of the tenant."
        },
        "clients": {
          "description": "The clients associated with the tenant.",
          "type": "array",
          "items": {
            "$ref": "./ClientEntity.schema.json"
          }
        }
      },
      "required": ["id", "name", "status", "clients"]
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/ClientEntity.schema.json",
    "fileMatch": ["a://b/ClientEntity*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/ClientEntity.schema.json",
      "title": "ClientEntity",
      "type": "object",
      "properties": {
        "allowedPresentationConfigs": {
          "nullable": true,
          "description": "List of presentation config IDs this client can use. If empty/null, all configs are allowed.",
          "example": ["age-verification", "kyc-basic"],
          "type": "array",
          "items": {
            "type": "string"
          }
        },
        "allowedIssuanceConfigs": {
          "nullable": true,
          "description": "List of issuance config IDs this client can use. If empty/null, all configs are allowed.",
          "example": ["pid", "mdl"],
          "type": "array",
          "items": {
            "type": "string"
          }
        },
        "clientId": {
          "type": "string",
          "description": "The unique identifier for the client."
        },
        "secret": {
          "type": "string",
          "description": "The secret key for the client."
        },
        "tenantId": {
          "type": "string",
          "description": "The unique identifier for the tenant that the client belongs to. Only null for accounts that manage tenants, that do not belong to a client"
        },
        "description": {
          "type": "string",
          "description": "The description of the client."
        },
        "roles": {
          "description": "The roles assigned to the client.",
          "type": "array",
          "items": {
            "type": "string",
            "enum": [
              "presentation:manage",
              "presentation:request",
              "issuance:manage",
              "issuance:offer",
              "clients:manage",
              "tenants:manage",
              "registrar:manage"
            ]
          }
        },
        "tenant": {
          "description": "The tenant that the client belongs to.",
          "allOf": [
            {
              "$ref": "./TenantEntity.schema.json"
            }
          ]
        }
      },
      "required": ["clientId", "roles"]
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/CreateTenantDto.schema.json",
    "fileMatch": ["a://b/CreateTenantDto*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/CreateTenantDto.schema.json",
      "title": "CreateTenantDto",
      "type": "object",
      "properties": {
        "statusListConfig": {
          "nullable": true,
          "description": "Status list configuration for this tenant. Only affects newly created status lists.",
          "allOf": [
            {
              "$ref": "./StatusListConfig.schema.json"
            }
          ]
        },
        "sessionConfig": {
          "description": "Session storage configuration. Controls TTL and cleanup behavior.",
          "allOf": [
            {
              "$ref": "./SessionStorageConfig.schema.json"
            }
          ]
        },
        "roles": {
          "type": "array",
          "items": {
            "type": "string",
            "enum": [
              "presentation:manage",
              "presentation:request",
              "issuance:manage",
              "issuance:offer",
              "clients:manage",
              "tenants:manage",
              "registrar:manage"
            ]
          }
        },
        "id": {
          "type": "string",
          "description": "The unique identifier for the tenant."
        },
        "name": {
          "type": "string",
          "description": "The name of the tenant."
        },
        "description": {
          "type": "string",
          "description": "The description of the tenant."
        }
      },
      "required": ["id", "name"]
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/UpdateTenantDto.schema.json",
    "fileMatch": ["a://b/UpdateTenantDto*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/UpdateTenantDto.schema.json",
      "title": "UpdateTenantDto",
      "type": "object",
      "properties": {
        "statusListConfig": {
          "nullable": true,
          "description": "Status list configuration for this tenant. Only affects newly created status lists.",
          "allOf": [
            {
              "$ref": "./StatusListConfig.schema.json"
            }
          ]
        },
        "sessionConfig": {
          "description": "Session storage configuration. Controls TTL and cleanup behavior.",
          "allOf": [
            {
              "$ref": "./SessionStorageConfig.schema.json"
            }
          ]
        },
        "name": {
          "type": "string",
          "description": "The name of the tenant."
        },
        "description": {
          "type": "string",
          "description": "The description of the tenant."
        },
        "roles": {
          "type": "array",
          "items": {
            "type": "string",
            "enum": [
              "presentation:manage",
              "presentation:request",
              "issuance:manage",
              "issuance:offer",
              "clients:manage",
              "tenants:manage",
              "registrar:manage"
            ]
          }
        }
      }
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/ClientSecretResponseDto.schema.json",
    "fileMatch": ["a://b/ClientSecretResponseDto*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/ClientSecretResponseDto.schema.json",
      "title": "ClientSecretResponseDto",
      "type": "object",
      "properties": {
        "secret": {
          "type": "string"
        }
      },
      "required": ["secret"]
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/UpdateClientDto.schema.json",
    "fileMatch": ["a://b/UpdateClientDto*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/UpdateClientDto.schema.json",
      "title": "UpdateClientDto",
      "type": "object",
      "properties": {
        "allowedPresentationConfigs": {
          "nullable": true,
          "description": "List of presentation config IDs this client can use. If empty/null, all configs are allowed.",
          "example": ["age-verification", "kyc-basic"],
          "type": "array",
          "items": {
            "type": "string"
          }
        },
        "allowedIssuanceConfigs": {
          "nullable": true,
          "description": "List of issuance config IDs this client can use. If empty/null, all configs are allowed.",
          "example": ["pid", "mdl"],
          "type": "array",
          "items": {
            "type": "string"
          }
        },
        "description": {
          "type": "string",
          "description": "The description of the client."
        },
        "roles": {
          "type": "array",
          "description": "The roles assigned to the client.",
          "items": {
            "type": "string",
            "enum": [
              "presentation:manage",
              "presentation:request",
              "issuance:manage",
              "issuance:offer",
              "clients:manage",
              "tenants:manage",
              "registrar:manage"
            ]
          }
        }
      },
      "required": ["roles"]
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/CreateClientDto.schema.json",
    "fileMatch": ["a://b/CreateClientDto*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/CreateClientDto.schema.json",
      "title": "CreateClientDto",
      "type": "object",
      "properties": {
        "allowedPresentationConfigs": {
          "nullable": true,
          "description": "List of presentation config IDs this client can use. If empty/null, all configs are allowed.",
          "example": ["age-verification", "kyc-basic"],
          "type": "array",
          "items": {
            "type": "string"
          }
        },
        "allowedIssuanceConfigs": {
          "nullable": true,
          "description": "List of issuance config IDs this client can use. If empty/null, all configs are allowed.",
          "example": ["pid", "mdl"],
          "type": "array",
          "items": {
            "type": "string"
          }
        },
        "clientId": {
          "type": "string",
          "description": "The unique identifier for the client."
        },
        "secret": {
          "type": "string",
          "description": "The secret key for the client."
        },
        "description": {
          "type": "string",
          "description": "The description of the client."
        },
        "roles": {
          "type": "array",
          "description": "The roles assigned to the client.",
          "items": {
            "type": "string",
            "enum": [
              "presentation:manage",
              "presentation:request",
              "issuance:manage",
              "issuance:offer",
              "clients:manage",
              "tenants:manage",
              "registrar:manage"
            ]
          }
        }
      },
      "required": ["clientId", "roles"]
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/DbKmsConfigDto.schema.json",
    "fileMatch": ["a://b/DbKmsConfigDto*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/DbKmsConfigDto.schema.json",
      "title": "DbKmsConfigDto",
      "type": "object",
      "properties": {}
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/VaultKmsConfigDto.schema.json",
    "fileMatch": ["a://b/VaultKmsConfigDto*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/VaultKmsConfigDto.schema.json",
      "title": "VaultKmsConfigDto",
      "type": "object",
      "properties": {
        "vaultUrl": {
          "type": "string",
          "description": "URL of the HashiCorp Vault instance. Supports ${ENV_VAR} placeholders.",
          "example": "${VAULT_URL}"
        },
        "vaultToken": {
          "type": "string",
          "description": "Authentication token for HashiCorp Vault. Supports ${ENV_VAR} placeholders.",
          "example": "${VAULT_TOKEN}"
        }
      },
      "required": ["vaultUrl", "vaultToken"]
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/KmsConfigDto.schema.json",
    "fileMatch": ["a://b/KmsConfigDto*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/KmsConfigDto.schema.json",
      "title": "KmsConfigDto",
      "type": "object",
      "properties": {
        "defaultProvider": {
          "type": "string",
          "description": "Name of the default KMS provider. Defaults to \"db\" if not set.",
          "example": "db"
        },
        "providers": {
          "type": "object",
          "properties": {
            "db": {
              "$ref": "./DbKmsConfigDto.schema.json"
            },
            "vault": {
              "$ref": "./VaultKmsConfigDto.schema.json"
            }
          },
          "required": []
        }
      },
      "required": ["providers"]
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/KmsProviderCapabilitiesDto.schema.json",
    "fileMatch": ["a://b/KmsProviderCapabilitiesDto*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/KmsProviderCapabilitiesDto.schema.json",
      "title": "KmsProviderCapabilitiesDto",
      "type": "object",
      "properties": {
        "canImport": {
          "type": "boolean",
          "description": "Whether the provider supports importing existing keys.",
          "example": true
        },
        "canCreate": {
          "type": "boolean",
          "description": "Whether the provider supports generating new keys.",
          "example": true
        },
        "canDelete": {
          "type": "boolean",
          "description": "Whether the provider supports deleting keys.",
          "example": true
        }
      },
      "required": ["canImport", "canCreate", "canDelete"]
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/KmsProviderInfoDto.schema.json",
    "fileMatch": ["a://b/KmsProviderInfoDto*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/KmsProviderInfoDto.schema.json",
      "title": "KmsProviderInfoDto",
      "type": "object",
      "properties": {
        "name": {
          "type": "string",
          "description": "Unique provider name (matches the key in kms.json).",
          "example": "db"
        },
        "capabilities": {
          "description": "Capabilities of this provider.",
          "allOf": [
            {
              "$ref": "./KmsProviderCapabilitiesDto.schema.json"
            }
          ]
        }
      },
      "required": ["name", "capabilities"]
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/KmsProvidersResponseDto.schema.json",
    "fileMatch": ["a://b/KmsProvidersResponseDto*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/KmsProvidersResponseDto.schema.json",
      "title": "KmsProvidersResponseDto",
      "type": "object",
      "properties": {
        "providers": {
          "description": "Detailed info for each registered KMS provider.",
          "type": "array",
          "items": {
            "$ref": "./KmsProviderInfoDto.schema.json"
          }
        },
        "default": {
          "type": "string",
          "description": "The default KMS provider name.",
          "example": "db"
        }
      },
      "required": ["providers", "default"]
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/CertUsageEntity.schema.json",
    "fileMatch": ["a://b/CertUsageEntity*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/CertUsageEntity.schema.json",
      "title": "CertUsageEntity",
      "type": "object",
      "properties": {
        "tenantId": {
          "type": "string"
        },
        "certId": {
          "type": "string"
        },
        "usage": {
          "type": "string",
          "enum": ["access", "signing", "trustList", "statusList"]
        },
        "cert": {
          "$ref": "./CertEntity.schema.json"
        }
      },
      "required": ["tenantId", "certId", "usage", "cert"]
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/KeyEntity.schema.json",
    "fileMatch": ["a://b/KeyEntity*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/KeyEntity.schema.json",
      "title": "KeyEntity",
      "type": "object",
      "properties": {
        "id": {
          "type": "string",
          "description": "Unique identifier for the key."
        },
        "description": {
          "type": "string",
          "description": "Description of the key."
        },
        "tenantId": {
          "type": "string",
          "description": "Tenant ID for the key."
        },
        "tenant": {
          "description": "The tenant that owns this object.",
          "allOf": [
            {
              "$ref": "./TenantEntity.schema.json"
            }
          ]
        },
        "key": {
          "type": "object",
          "description": "The key material.\nEncrypted at rest using AES-256-GCM."
        },
        "usage": {
          "type": "object",
          "description": "The usage type of the key."
        },
        "kmsProvider": {
          "type": "string",
          "description": "The KMS provider used for this key.\nReferences a configured KMS provider name."
        },
        "certificates": {
          "description": "Certificates associated with this key.",
          "type": "array",
          "items": {
            "$ref": "./CertEntity.schema.json"
          }
        },
        "createdAt": {
          "format": "date-time",
          "type": "string",
          "description": "The timestamp when the key was created."
        },
        "updatedAt": {
          "format": "date-time",
          "type": "string",
          "description": "The timestamp when the key was last updated."
        }
      },
      "required": [
        "id",
        "tenantId",
        "tenant",
        "key",
        "usage",
        "kmsProvider",
        "certificates",
        "createdAt",
        "updatedAt"
      ]
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/CertEntity.schema.json",
    "fileMatch": ["a://b/CertEntity*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/CertEntity.schema.json",
      "title": "CertEntity",
      "type": "object",
      "properties": {
        "keyId": {
          "type": "string",
          "description": "The key ID this certificate is associated with",
          "example": "039af178-3ca0-48f4-a2e4-7b1209f30376"
        },
        "id": {
          "type": "string",
          "description": "Unique identifier for the key."
        },
        "tenantId": {
          "type": "string",
          "description": "Tenant ID for the key."
        },
        "tenant": {
          "description": "The tenant that owns this object.",
          "allOf": [
            {
              "$ref": "./TenantEntity.schema.json"
            }
          ]
        },
        "crt": {
          "description": "Certificate chain in PEM format (leaf first, then intermediates/CA).",
          "type": "array",
          "items": {
            "type": "string"
          }
        },
        "usages": {
          "type": "array",
          "items": {
            "$ref": "./CertUsageEntity.schema.json"
          }
        },
        "description": {
          "type": "string",
          "description": "Description of the key."
        },
        "key": {
          "$ref": "./KeyEntity.schema.json"
        },
        "createdAt": {
          "format": "date-time",
          "type": "string",
          "description": "The timestamp when the certificate was created."
        },
        "updatedAt": {
          "format": "date-time",
          "type": "string",
          "description": "The timestamp when the certificate was last updated."
        }
      },
      "required": [
        "keyId",
        "id",
        "tenantId",
        "tenant",
        "crt",
        "usages",
        "key",
        "createdAt",
        "updatedAt"
      ]
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/Key.schema.json",
    "fileMatch": ["a://b/Key*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/Key.schema.json",
      "title": "Key",
      "type": "object",
      "properties": {
        "kty": {
          "type": "string"
        },
        "x": {
          "type": "string"
        },
        "y": {
          "type": "string"
        },
        "crv": {
          "type": "string"
        },
        "d": {
          "type": "string"
        },
        "alg": {
          "type": "string"
        }
      },
      "required": ["kty", "x", "y", "crv", "d", "alg"]
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/KeyImportDto.schema.json",
    "fileMatch": ["a://b/KeyImportDto*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/KeyImportDto.schema.json",
      "title": "KeyImportDto",
      "type": "object",
      "properties": {
        "kmsProvider": {
          "type": "string",
          "description": "KMS provider name to use for this key. Defaults to the configured default.",
          "example": "db"
        },
        "key": {
          "description": "The private key in JWK format.",
          "allOf": [
            {
              "$ref": "./Key.schema.json"
            }
          ]
        },
        "id": {
          "type": "string",
          "description": "Unique identifier for the key."
        },
        "description": {
          "type": "string",
          "description": "Description of the key."
        }
      },
      "required": ["key", "id"]
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/UpdateKeyDto.schema.json",
    "fileMatch": ["a://b/UpdateKeyDto*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/UpdateKeyDto.schema.json",
      "title": "UpdateKeyDto",
      "type": "object",
      "properties": {
        "kmsProvider": {
          "type": "string",
          "description": "KMS provider name to use for this key. Defaults to the configured default.",
          "example": "db"
        },
        "id": {
          "type": "string",
          "description": "Unique identifier for the key."
        },
        "description": {
          "type": "string",
          "description": "Description of the key."
        }
      },
      "required": ["id"]
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/CertImportDto.schema.json",
    "fileMatch": ["a://b/CertImportDto*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/CertImportDto.schema.json",
      "title": "CertImportDto",
      "type": "object",
      "properties": {
        "keyId": {
          "type": "string",
          "description": "The key ID this certificate is associated with",
          "example": "039af178-3ca0-48f4-a2e4-7b1209f30376"
        },
        "id": {
          "type": "string"
        },
        "certUsageTypes": {
          "description": "Usage types for the certificate.",
          "type": "array",
          "items": {
            "type": "string",
            "enum": ["access", "signing", "trustList", "statusList"]
          }
        },
        "crt": {
          "description": "Certificate chain in PEM format (leaf first, then intermediates/CA).\nIf not provided, a self-signed certificate will be generated.",
          "type": "array",
          "items": {
            "type": "string"
          }
        },
        "subjectName": {
          "type": "string",
          "description": "Subject name (CN) for self-signed certificate generation.\nIf not provided, the tenant name will be used."
        },
        "description": {
          "type": "string",
          "description": "Description of the key."
        }
      },
      "required": ["keyId", "certUsageTypes"]
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/CertResponseDto.schema.json",
    "fileMatch": ["a://b/CertResponseDto*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/CertResponseDto.schema.json",
      "title": "CertResponseDto",
      "type": "object",
      "properties": {
        "id": {
          "type": "string",
          "description": "The ID of the created self-signed certificate."
        }
      },
      "required": ["id"]
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/CertUpdateDto.schema.json",
    "fileMatch": ["a://b/CertUpdateDto*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/CertUpdateDto.schema.json",
      "title": "CertUpdateDto",
      "type": "object",
      "properties": {
        "certUsageTypes": {
          "type": "array",
          "description": "Usage types for the certificate.",
          "items": {
            "type": "string",
            "enum": ["access", "signing", "trustList", "statusList"]
          }
        },
        "usages": {
          "type": "array",
          "items": {
            "$ref": "./CertUsageEntity.schema.json"
          }
        },
        "description": {
          "type": "string",
          "description": "Description of the key."
        }
      },
      "required": ["certUsageTypes", "usages"]
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/StatusListImportDto.schema.json",
    "fileMatch": ["a://b/StatusListImportDto*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/StatusListImportDto.schema.json",
      "title": "StatusListImportDto",
      "type": "object",
      "properties": {
        "id": {
          "type": "string",
          "description": "Unique identifier for the status list"
        },
        "credentialConfigurationId": {
          "type": "string",
          "nullable": true,
          "description": "Credential configuration ID to bind this list exclusively to. Leave empty for a shared list.",
          "example": "org.iso.18013.5.1.mDL"
        },
        "certId": {
          "type": "string",
          "description": "Certificate ID to use for signing. Leave empty to use the tenant's default StatusList certificate.",
          "example": "my-status-list-cert"
        },
        "capacity": {
          "type": "number",
          "description": "Capacity of the status list. If not provided, uses tenant or global defaults.",
          "minimum": 100,
          "example": 10000
        },
        "bits": {
          "type": "number",
          "description": "Bits per status value. If not provided, uses tenant or global defaults.",
          "enum": [1, 2, 4, 8],
          "example": 1
        }
      },
      "required": ["id"]
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/StatusListAggregationDto.schema.json",
    "fileMatch": ["a://b/StatusListAggregationDto*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/StatusListAggregationDto.schema.json",
      "title": "StatusListAggregationDto",
      "type": "object",
      "properties": {
        "status_lists": {
          "description": "Array of status list token URIs",
          "example": [
            "https://example.com/tenant-123/status-management/status-list/list-1",
            "https://example.com/tenant-123/status-management/status-list/list-2"
          ],
          "type": "array",
          "items": {
            "type": "string"
          }
        }
      },
      "required": ["status_lists"]
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/UpdateStatusListConfigDto.schema.json",
    "fileMatch": ["a://b/UpdateStatusListConfigDto*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/UpdateStatusListConfigDto.schema.json",
      "title": "UpdateStatusListConfigDto",
      "type": "object",
      "properties": {
        "capacity": {
          "type": "number",
          "nullable": true,
          "description": "The capacity of the status list. Set to null to reset to global default.",
          "minimum": 100,
          "example": 10000
        },
        "bits": {
          "type": "number",
          "nullable": true,
          "description": "Bits per status entry. Set to null to reset to global default.",
          "enum": [1, 2, 4, 8]
        },
        "ttl": {
          "type": "number",
          "nullable": true,
          "description": "TTL in seconds for the status list JWT. Set to null to reset to global default.",
          "minimum": 60,
          "example": 3600
        },
        "immediateUpdate": {
          "type": "boolean",
          "nullable": true,
          "description": "If true, regenerate JWT on every status change. Set to null to reset to default (false)."
        },
        "enableAggregation": {
          "type": "boolean",
          "nullable": true,
          "description": "If true, include aggregation_uri in status list JWTs for pre-fetching support. Set to null to reset to default (true)."
        }
      }
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/StatusListResponseDto.schema.json",
    "fileMatch": ["a://b/StatusListResponseDto*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/StatusListResponseDto.schema.json",
      "title": "StatusListResponseDto",
      "type": "object",
      "properties": {
        "id": {
          "type": "string",
          "description": "Unique identifier for the status list",
          "example": "550e8400-e29b-41d4-a716-446655440000"
        },
        "tenantId": {
          "type": "string",
          "description": "The tenant ID",
          "example": "root"
        },
        "credentialConfigurationId": {
          "type": "string",
          "nullable": true,
          "description": "Credential configuration ID this list is bound to. Null means shared.",
          "example": "org.iso.18013.5.1.mDL"
        },
        "certId": {
          "type": "string",
          "nullable": true,
          "description": "Certificate ID used for signing. Null means using the tenant's default.",
          "example": "my-status-list-cert"
        },
        "bits": {
          "type": "number",
          "description": "Bits per status value",
          "enum": [1, 2, 4, 8],
          "example": 1
        },
        "capacity": {
          "type": "number",
          "description": "Total capacity of the status list",
          "example": 10000
        },
        "usedEntries": {
          "type": "number",
          "description": "Number of entries in use",
          "example": 150
        },
        "availableEntries": {
          "type": "number",
          "description": "Number of available entries",
          "example": 9850
        },
        "uri": {
          "type": "string",
          "description": "The public URI for this status list",
          "example": "https://example.com/demo/status-management/status-list/550e8400-e29b-41d4-a716-446655440000"
        },
        "createdAt": {
          "format": "date-time",
          "type": "string",
          "description": "Creation timestamp",
          "example": "2024-01-15T10:30:00.000Z"
        },
        "expiresAt": {
          "format": "date-time",
          "type": "string",
          "nullable": true,
          "description": "JWT expiration timestamp. Null if JWT has not been generated yet.",
          "example": "2024-01-15T11:30:00.000Z"
        }
      },
      "required": [
        "id",
        "tenantId",
        "bits",
        "capacity",
        "usedEntries",
        "availableEntries",
        "uri",
        "createdAt"
      ]
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/CreateStatusListDto.schema.json",
    "fileMatch": ["a://b/CreateStatusListDto*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/CreateStatusListDto.schema.json",
      "title": "CreateStatusListDto",
      "type": "object",
      "properties": {
        "credentialConfigurationId": {
          "type": "string",
          "description": "Credential configuration ID to bind this list exclusively to. Leave empty for a shared list.",
          "example": "org.iso.18013.5.1.mDL"
        },
        "certId": {
          "type": "string",
          "description": "Certificate ID to use for signing. Leave empty to use the tenant's default StatusList certificate.",
          "example": "my-status-list-cert"
        },
        "bits": {
          "type": "number",
          "description": "Bits per status value. More bits allow more status states. Defaults to tenant configuration.",
          "enum": [1, 2, 4, 8],
          "example": 1
        },
        "capacity": {
          "type": "number",
          "description": "Maximum number of credential status entries. Defaults to tenant configuration.",
          "minimum": 1000,
          "example": 100000
        }
      }
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/UpdateStatusListDto.schema.json",
    "fileMatch": ["a://b/UpdateStatusListDto*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/UpdateStatusListDto.schema.json",
      "title": "UpdateStatusListDto",
      "type": "object",
      "properties": {
        "credentialConfigurationId": {
          "type": "string",
          "nullable": true,
          "description": "Credential configuration ID to bind this list exclusively to. Set to null to make this a shared list.",
          "example": "org.iso.18013.5.1.mDL"
        },
        "certId": {
          "type": "string",
          "nullable": true,
          "description": "Certificate ID to use for signing. Set to null to use the tenant's default StatusList certificate.",
          "example": "my-status-list-cert"
        }
      }
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/AuthorizeQueries.schema.json",
    "fileMatch": ["a://b/AuthorizeQueries*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/AuthorizeQueries.schema.json",
      "title": "AuthorizeQueries",
      "type": "object",
      "properties": {
        "issuer_state": {
          "type": "string"
        },
        "response_type": {
          "type": "string"
        },
        "client_id": {
          "type": "string"
        },
        "redirect_uri": {
          "type": "string"
        },
        "resource": {
          "type": "string"
        },
        "scope": {
          "type": "string"
        },
        "code_challenge": {
          "type": "string"
        },
        "code_challenge_method": {
          "type": "string"
        },
        "dpop_jkt": {
          "type": "string"
        },
        "request_uri": {
          "type": "string"
        },
        "auth_session": {
          "type": "string"
        },
        "state": {
          "type": "string"
        }
      }
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/WebHookAuthConfigNone.schema.json",
    "fileMatch": ["a://b/WebHookAuthConfigNone*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/WebHookAuthConfigNone.schema.json",
      "title": "WebHookAuthConfigNone",
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "description": "The type of authentication used for the webhook.",
          "enum": ["none"]
        }
      },
      "required": ["type"]
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/ApiKeyConfig.schema.json",
    "fileMatch": ["a://b/ApiKeyConfig*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/ApiKeyConfig.schema.json",
      "title": "ApiKeyConfig",
      "type": "object",
      "properties": {
        "headerName": {
          "type": "string",
          "description": "The name of the header where the API key will be sent."
        },
        "value": {
          "type": "string",
          "description": "The value of the API key to be sent in the header."
        }
      },
      "required": ["headerName", "value"]
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/WebHookAuthConfigHeader.schema.json",
    "fileMatch": ["a://b/WebHookAuthConfigHeader*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/WebHookAuthConfigHeader.schema.json",
      "title": "WebHookAuthConfigHeader",
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "description": "The type of authentication used for the webhook.",
          "enum": ["apiKey"]
        },
        "config": {
          "description": "Configuration for API key authentication.\nThis is required if the type is 'apiKey'.",
          "allOf": [
            {
              "$ref": "./ApiKeyConfig.schema.json"
            }
          ]
        }
      },
      "required": ["type", "config"]
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/WebhookConfig.schema.json",
    "fileMatch": ["a://b/WebhookConfig*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/WebhookConfig.schema.json",
      "title": "WebhookConfig",
      "type": "object",
      "properties": {
        "auth": {
          "description": "Optional authentication configuration for the webhook.\nIf not provided, no authentication will be used.",
          "oneOf": [
            {
              "$ref": "./WebHookAuthConfigNone.schema.json"
            },
            {
              "$ref": "./WebHookAuthConfigHeader.schema.json"
            }
          ]
        },
        "url": {
          "type": "string",
          "description": "The URL to which the webhook will send notifications."
        }
      },
      "required": ["auth", "url"]
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/OfferRequestDto.schema.json",
    "fileMatch": ["a://b/OfferRequestDto*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/OfferRequestDto.schema.json",
      "title": "OfferRequestDto",
      "type": "object",
      "properties": {
        "response_type": {
          "enum": ["uri", "dc-api"],
          "type": "string",
          "examples": [
            {
              "value": "qrcode"
            }
          ],
          "description": "The type of response expected for the offer request."
        },
        "credentialClaims": {
          "type": "object",
          "description": "Credential claims configuration per credential. Keys must match credentialConfigurationIds.",
          "properties": {
            "additionalProperties": {
              "oneOf": [
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "type": "string",
                      "enum": ["inline"]
                    },
                    "claims": {
                      "type": "object",
                      "additionalProperties": true
                    }
                  },
                  "required": ["type", "claims"]
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "type": "string",
                      "enum": ["webhook"]
                    },
                    "webhook": {
                      "type": "object"
                    }
                  },
                  "required": ["type", "webhook"]
                }
              ]
            }
          },
          "example": {
            "citizen": {
              "type": "inline",
              "claims": {
                "given_name": "John",
                "family_name": "Doe"
              }
            }
          }
        },
        "flow": {
          "description": "The flow type for the offer request.",
          "enum": ["authorization_code", "pre_authorized_code"],
          "type": "string"
        },
        "tx_code": {
          "type": "string",
          "description": "Transaction code for pre-authorized code flow."
        },
        "tx_code_description": {
          "type": "string",
          "description": "Description for the transaction code (e.g., \"Please enter the PIN sent to your email\")."
        },
        "credentialConfigurationIds": {
          "description": "List of credential configuration ids to be included in the offer.",
          "type": "array",
          "items": {
            "type": "string"
          }
        },
        "authorization_server": {
          "type": "string",
          "description": "Optional authorization server to be used for this issuance flow."
        },
        "notifyWebhook": {
          "description": "Webhook to notify about the status of the issuance process.",
          "allOf": [
            {
              "$ref": "./WebhookConfig.schema.json"
            }
          ]
        }
      },
      "required": ["response_type", "flow", "credentialConfigurationIds"]
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/TransactionData.schema.json",
    "fileMatch": ["a://b/TransactionData*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/TransactionData.schema.json",
      "title": "TransactionData",
      "type": "object",
      "properties": {
        "type": {
          "type": "string"
        },
        "credential_ids": {
          "type": "array",
          "items": {
            "type": "string"
          }
        }
      },
      "required": ["type", "credential_ids"]
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/Session.schema.json",
    "fileMatch": ["a://b/Session*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/Session.schema.json",
      "title": "Session",
      "type": "object",
      "properties": {
        "status": {
          "description": "Status of the session.",
          "enum": ["active", "fetched", "completed", "expired", "failed"],
          "type": "string"
        },
        "id": {
          "type": "string",
          "description": "Unique identifier for the session."
        },
        "createdAt": {
          "format": "date-time",
          "type": "string",
          "description": "The timestamp when the request was created."
        },
        "updatedAt": {
          "format": "date-time",
          "type": "string",
          "description": "The timestamp when the request was last updated."
        },
        "expiresAt": {
          "format": "date-time",
          "type": "string",
          "description": "The timestamp when the request is set to expire."
        },
        "useDcApi": {
          "type": "boolean",
          "description": "Flag indicating whether to use the DC API for the presentation request."
        },
        "tenantId": {
          "type": "string",
          "description": "Tenant ID for multi-tenancy support."
        },
        "tenant": {
          "description": "The tenant that owns this object.",
          "allOf": [
            {
              "$ref": "./TenantEntity.schema.json"
            }
          ]
        },
        "authorization_code": {
          "type": "string"
        },
        "request_uri": {
          "type": "string",
          "description": "Request URI from the authorization request."
        },
        "auth_queries": {
          "description": "Authorization queries associated with the session.\nEncrypted at rest.",
          "allOf": [
            {
              "$ref": "./AuthorizeQueries.schema.json"
            }
          ]
        },
        "offer": {
          "description": "Credential offer object containing details about the credential offer or presentation request.\nEncrypted at rest.",
          "type": "object"
        },
        "offerUrl": {
          "type": "string",
          "description": "Offer URL for the credential offer."
        },
        "credentialPayload": {
          "description": "Credential payload containing the offer request details.\nEncrypted at rest - may contain sensitive claim data.",
          "allOf": [
            {
              "$ref": "./OfferRequestDto.schema.json"
            }
          ]
        },
        "notifyWebhook": {
          "description": "Webhook configuration to send the result of the notification response.",
          "allOf": [
            {
              "$ref": "./WebhookConfig.schema.json"
            }
          ]
        },
        "notifications": {
          "description": "Notifications associated with the session.",
          "type": "array",
          "items": {
            "type": "object"
          }
        },
        "requestId": {
          "type": "string"
        },
        "requestUrl": {
          "type": "string",
          "description": "The URL of the presentation auth request."
        },
        "requestObject": {
          "type": "string",
          "description": "Signed presentation auth request."
        },
        "credentials": {
          "description": "Verified credentials from the presentation process.\nEncrypted at rest - contains personal information.",
          "type": "array",
          "items": {
            "type": "object"
          }
        },
        "vp_nonce": {
          "type": "string",
          "description": "Noncce from the Verifiable Presentation request."
        },
        "clientId": {
          "type": "string",
          "description": "Client ID used in the OID4VP authorization request."
        },
        "responseUri": {
          "type": "string",
          "description": "Response URI used in the OID4VP authorization request."
        },
        "redirectUri": {
          "type": "string",
          "nullable": true,
          "description": "Redirect URI to which the user-agent should be redirected after the presentation is completed."
        },
        "parsedWebhook": {
          "description": "Where to send the claims webhook response.",
          "allOf": [
            {
              "$ref": "./WebhookConfig.schema.json"
            }
          ]
        },
        "transaction_data": {
          "description": "Transaction data to include in the OID4VP authorization request.\nCan be overridden per-request from the presentation configuration.",
          "type": "array",
          "items": {
            "$ref": "./TransactionData.schema.json"
          }
        },
        "externalIssuer": {
          "type": "string"
        },
        "externalSubject": {
          "type": "string",
          "description": "The subject (sub) from the external authorization server token.\nUsed to identify the user at the external AS."
        }
      },
      "required": [
        "status",
        "id",
        "createdAt",
        "updatedAt",
        "useDcApi",
        "tenantId",
        "tenant",
        "notifications"
      ]
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/StatusUpdateDto.schema.json",
    "fileMatch": ["a://b/StatusUpdateDto*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/StatusUpdateDto.schema.json",
      "title": "StatusUpdateDto",
      "type": "object",
      "properties": {
        "sessionId": {
          "type": "string",
          "description": "The session ID of the user"
        },
        "credentialConfigurationId": {
          "type": "string",
          "description": "The ID of the credential configuration\nThis is optional, if not provided, all credentials will be revoked of the session."
        },
        "status": {
          "type": "number",
          "description": "The status of the credential\n0 = valid, 1 = revoked, 2 = suspended"
        }
      },
      "required": ["sessionId", "status"]
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/UpdateSessionConfigDto.schema.json",
    "fileMatch": ["a://b/UpdateSessionConfigDto*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/UpdateSessionConfigDto.schema.json",
      "title": "UpdateSessionConfigDto",
      "type": "object",
      "properties": {
        "ttlSeconds": {
          "type": "number",
          "nullable": true,
          "description": "Time-to-live for sessions in seconds. Set to null to use global default.",
          "minimum": 60,
          "example": 86400
        },
        "cleanupMode": {
          "description": "Cleanup mode: 'full' deletes everything, 'anonymize' keeps metadata but removes PII.",
          "enum": ["full", "anonymize"],
          "type": "string",
          "default": "full"
        }
      }
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/AuthenticationMethodNone.schema.json",
    "fileMatch": ["a://b/AuthenticationMethodNone*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/AuthenticationMethodNone.schema.json",
      "title": "AuthenticationMethodNone",
      "type": "object",
      "properties": {
        "method": {
          "type": "string",
          "enum": ["none"]
        }
      },
      "required": ["method"]
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/AuthenticationUrlConfig.schema.json",
    "fileMatch": ["a://b/AuthenticationUrlConfig*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/AuthenticationUrlConfig.schema.json",
      "title": "AuthenticationUrlConfig",
      "type": "object",
      "properties": {
        "url": {
          "type": "string",
          "description": "The URL used in the OID4VCI authorized code flow.\nThis URL is where users will be redirected for authentication."
        },
        "webhook": {
          "description": "Optional webhook configuration for authentication callbacks",
          "allOf": [
            {
              "$ref": "./WebhookConfig.schema.json"
            }
          ]
        }
      },
      "required": ["url"]
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/AuthenticationMethodAuth.schema.json",
    "fileMatch": ["a://b/AuthenticationMethodAuth*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/AuthenticationMethodAuth.schema.json",
      "title": "AuthenticationMethodAuth",
      "type": "object",
      "properties": {
        "method": {
          "type": "string",
          "enum": ["auth"]
        },
        "config": {
          "$ref": "./AuthenticationUrlConfig.schema.json"
        }
      },
      "required": ["method", "config"]
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/PresentationDuringIssuanceConfig.schema.json",
    "fileMatch": ["a://b/PresentationDuringIssuanceConfig*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/PresentationDuringIssuanceConfig.schema.json",
      "title": "PresentationDuringIssuanceConfig",
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "description": "Link to the presentation configuration that is relevant for the issuance process"
        }
      },
      "required": ["type"]
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/AuthenticationMethodPresentation.schema.json",
    "fileMatch": ["a://b/AuthenticationMethodPresentation*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/AuthenticationMethodPresentation.schema.json",
      "title": "AuthenticationMethodPresentation",
      "type": "object",
      "properties": {
        "method": {
          "type": "string",
          "enum": ["presentationDuringIssuance"]
        },
        "config": {
          "$ref": "./PresentationDuringIssuanceConfig.schema.json"
        }
      },
      "required": ["method", "config"]
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/UpstreamOidcConfig.schema.json",
    "fileMatch": ["a://b/UpstreamOidcConfig*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/UpstreamOidcConfig.schema.json",
      "title": "UpstreamOidcConfig",
      "type": "object",
      "properties": {
        "issuer": {
          "type": "string",
          "description": "The OIDC issuer URL of the upstream provider",
          "example": "https://auth.example.com/realms/myrealm",
          "format": "uri"
        },
        "clientId": {
          "type": "string",
          "description": "The client ID registered with the upstream provider",
          "example": "eudiplo-chained-as"
        },
        "clientSecret": {
          "type": "string",
          "description": "The client secret for confidential clients"
        },
        "scopes": {
          "description": "Scopes to request from the upstream provider",
          "default": ["openid", "profile"],
          "type": "array",
          "items": {
            "type": "string"
          }
        }
      },
      "required": ["issuer", "clientId"]
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/ChainedAsTokenConfig.schema.json",
    "fileMatch": ["a://b/ChainedAsTokenConfig*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/ChainedAsTokenConfig.schema.json",
      "title": "ChainedAsTokenConfig",
      "type": "object",
      "properties": {
        "lifetimeSeconds": {
          "type": "number",
          "description": "Access token lifetime in seconds",
          "minimum": 60,
          "default": 3600
        },
        "signingKeyId": {
          "type": "string",
          "description": "Key ID for token signing"
        }
      }
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/ChainedAsConfig.schema.json",
    "fileMatch": ["a://b/ChainedAsConfig*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/ChainedAsConfig.schema.json",
      "title": "ChainedAsConfig",
      "type": "object",
      "properties": {
        "enabled": {
          "type": "boolean",
          "description": "Enable chained AS mode",
          "default": false
        },
        "upstream": {
          "description": "Upstream OIDC provider configuration",
          "allOf": [
            {
              "$ref": "./UpstreamOidcConfig.schema.json"
            }
          ]
        },
        "token": {
          "description": "Token configuration",
          "allOf": [
            {
              "$ref": "./ChainedAsTokenConfig.schema.json"
            }
          ]
        },
        "requireDPoP": {
          "type": "boolean",
          "description": "Require DPoP binding for tokens",
          "default": true
        }
      },
      "required": ["enabled"]
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/DisplayLogo.schema.json",
    "fileMatch": ["a://b/DisplayLogo*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/DisplayLogo.schema.json",
      "title": "DisplayLogo",
      "type": "object",
      "properties": {
        "uri": {
          "type": "string"
        },
        "alt_text": {
          "type": "string"
        }
      },
      "required": ["uri"]
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/DisplayInfo.schema.json",
    "fileMatch": ["a://b/DisplayInfo*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/DisplayInfo.schema.json",
      "title": "DisplayInfo",
      "type": "object",
      "properties": {
        "name": {
          "type": "string"
        },
        "locale": {
          "type": "string"
        },
        "logo": {
          "$ref": "./DisplayLogo.schema.json"
        }
      }
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/IssuanceConfig.schema.json",
    "fileMatch": ["a://b/IssuanceConfig*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/IssuanceConfig.schema.json",
      "title": "IssuanceConfig",
      "type": "object",
      "properties": {
        "chainedAs": {
          "description": "Configuration for Chained Authorization Server mode.\nWhen enabled, EUDIPLO acts as an OAuth AS facade, delegating user authentication\nto an upstream OIDC provider while issuing its own tokens with issuer_state.",
          "allOf": [
            {
              "$ref": "./ChainedAsConfig.schema.json"
            }
          ]
        },
        "tenant": {
          "description": "The tenant that owns this object.",
          "allOf": [
            {
              "$ref": "./TenantEntity.schema.json"
            }
          ]
        },
        "authServers": {
          "description": "Authentication server URL for the issuance process.",
          "type": "array",
          "items": {
            "type": "string"
          }
        },
        "batchSize": {
          "type": "number",
          "description": "Value to determine the amount of credentials that are issued in a batch.\nDefault is 1."
        },
        "dPopRequired": {
          "type": "boolean",
          "description": "Indicates whether DPoP is required for the issuance process. Default value is true."
        },
        "walletAttestationRequired": {
          "type": "boolean",
          "description": "Indicates whether wallet attestation is required for the token endpoint.\nWhen enabled, wallets must provide OAuth-Client-Attestation headers.\nDefault value is false."
        },
        "walletProviderTrustLists": {
          "description": "URLs of trust lists containing trusted wallet providers.\nThe wallet attestation's X.509 certificate will be validated against these trust lists.\nIf empty and walletAttestationRequired is true, all wallet providers are rejected.",
          "type": "array",
          "items": {
            "type": "string"
          }
        },
        "display": {
          "type": "array",
          "items": {
            "$ref": "./DisplayInfo.schema.json"
          }
        },
        "createdAt": {
          "format": "date-time",
          "type": "string",
          "description": "The timestamp when the VP request was created."
        },
        "updatedAt": {
          "format": "date-time",
          "type": "string",
          "description": "The timestamp when the VP request was last updated."
        }
      },
      "required": ["tenant", "display", "createdAt", "updatedAt"]
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/IssuanceDto.schema.json",
    "fileMatch": ["a://b/IssuanceDto*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/IssuanceDto.schema.json",
      "title": "IssuanceDto",
      "type": "object",
      "properties": {
        "chainedAs": {
          "description": "Configuration for Chained Authorization Server mode.\nWhen enabled, EUDIPLO acts as an OAuth AS facade, delegating user authentication\nto an upstream OIDC provider while issuing its own tokens with issuer_state.",
          "allOf": [
            {
              "$ref": "./ChainedAsConfig.schema.json"
            }
          ]
        },
        "authServers": {
          "description": "Authentication server URL for the issuance process.",
          "type": "array",
          "items": {
            "type": "string"
          }
        },
        "batchSize": {
          "type": "number",
          "description": "Value to determine the amount of credentials that are issued in a batch.\nDefault is 1."
        },
        "dPopRequired": {
          "type": "boolean",
          "description": "Indicates whether DPoP is required for the issuance process. Default value is true."
        },
        "walletAttestationRequired": {
          "type": "boolean",
          "description": "Indicates whether wallet attestation is required for the token endpoint.\nWhen enabled, wallets must provide OAuth-Client-Attestation headers.\nDefault value is false."
        },
        "walletProviderTrustLists": {
          "description": "URLs of trust lists containing trusted wallet providers.\nThe wallet attestation's X.509 certificate will be validated against these trust lists.\nIf empty and walletAttestationRequired is true, all wallet providers are rejected.",
          "type": "array",
          "items": {
            "type": "string"
          }
        },
        "display": {
          "type": "array",
          "items": {
            "$ref": "./DisplayInfo.schema.json"
          }
        }
      },
      "required": ["display"]
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/ClaimsQuery.schema.json",
    "fileMatch": ["a://b/ClaimsQuery*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/ClaimsQuery.schema.json",
      "title": "ClaimsQuery",
      "type": "object",
      "properties": {
        "id": {
          "type": "string"
        },
        "path": {
          "type": "array",
          "items": {
            "type": "string"
          }
        },
        "values": {
          "type": "array",
          "items": {
            "type": "string"
          }
        }
      },
      "required": ["path"]
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/TrustedAuthorityQuery.schema.json",
    "fileMatch": ["a://b/TrustedAuthorityQuery*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/TrustedAuthorityQuery.schema.json",
      "title": "TrustedAuthorityQuery",
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": ["aki", "etsi_tl"]
        },
        "values": {
          "type": "array",
          "items": {
            "type": "string"
          }
        }
      },
      "required": ["type", "values"]
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/CredentialQuery.schema.json",
    "fileMatch": ["a://b/CredentialQuery*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/CredentialQuery.schema.json",
      "title": "CredentialQuery",
      "type": "object",
      "properties": {
        "id": {
          "type": "string"
        },
        "format": {
          "type": "string"
        },
        "multiple": {
          "type": "boolean"
        },
        "claims": {
          "type": "array",
          "items": {
            "$ref": "./ClaimsQuery.schema.json"
          }
        },
        "meta": {
          "type": "object"
        },
        "trusted_authorities": {
          "type": "array",
          "items": {
            "$ref": "./TrustedAuthorityQuery.schema.json"
          }
        }
      },
      "required": ["id", "format", "meta"]
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/CredentialSetQuery.schema.json",
    "fileMatch": ["a://b/CredentialSetQuery*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/CredentialSetQuery.schema.json",
      "title": "CredentialSetQuery",
      "type": "object",
      "properties": {
        "options": {
          "type": "array",
          "items": {
            "type": "array",
            "items": {
              "type": "string"
            }
          }
        },
        "required": {
          "type": "boolean"
        }
      },
      "required": ["options"]
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/PolicyCredential.schema.json",
    "fileMatch": ["a://b/PolicyCredential*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/PolicyCredential.schema.json",
      "title": "PolicyCredential",
      "type": "object",
      "properties": {
        "claims": {
          "type": "array",
          "items": {
            "$ref": "./ClaimsQuery.schema.json"
          }
        },
        "credentials": {
          "type": "array",
          "items": {
            "$ref": "./CredentialQuery.schema.json"
          }
        },
        "credential_sets": {
          "type": "array",
          "items": {
            "$ref": "./CredentialSetQuery.schema.json"
          }
        }
      },
      "required": ["credentials"]
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/AttestationBasedPolicy.schema.json",
    "fileMatch": ["a://b/AttestationBasedPolicy*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/AttestationBasedPolicy.schema.json",
      "title": "AttestationBasedPolicy",
      "type": "object",
      "properties": {
        "policy": {
          "type": "string",
          "enum": ["attestationBased"]
        },
        "values": {
          "type": "array",
          "items": {
            "$ref": "./PolicyCredential.schema.json"
          }
        }
      },
      "required": ["policy", "values"]
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/NoneTrustPolicy.schema.json",
    "fileMatch": ["a://b/NoneTrustPolicy*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/NoneTrustPolicy.schema.json",
      "title": "NoneTrustPolicy",
      "type": "object",
      "properties": {
        "policy": {
          "type": "string",
          "enum": ["none"]
        }
      },
      "required": ["policy"]
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/AllowListPolicy.schema.json",
    "fileMatch": ["a://b/AllowListPolicy*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/AllowListPolicy.schema.json",
      "title": "AllowListPolicy",
      "type": "object",
      "properties": {
        "policy": {
          "type": "string",
          "enum": ["allowList"]
        },
        "values": {
          "type": "array",
          "items": {
            "type": "string"
          }
        }
      },
      "required": ["policy", "values"]
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/RootOfTrustPolicy.schema.json",
    "fileMatch": ["a://b/RootOfTrustPolicy*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/RootOfTrustPolicy.schema.json",
      "title": "RootOfTrustPolicy",
      "type": "object",
      "properties": {
        "policy": {
          "type": "string",
          "enum": ["rootOfTrust"]
        },
        "values": {
          "type": "string"
        }
      },
      "required": ["policy", "values"]
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/VCT.schema.json",
    "fileMatch": ["a://b/VCT*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/VCT.schema.json",
      "title": "VCT",
      "type": "object",
      "properties": {
        "vct": {
          "type": "string"
        },
        "name": {
          "type": "string"
        },
        "description": {
          "type": "string"
        },
        "extends": {
          "type": "string"
        },
        "extends#integrity": {
          "type": "string"
        },
        "schema_uri": {
          "type": "string"
        },
        "schema_uri#integrity": {
          "type": "string"
        }
      }
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/IaeActionOpenid4vpPresentation.schema.json",
    "fileMatch": ["a://b/IaeActionOpenid4vpPresentation*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/IaeActionOpenid4vpPresentation.schema.json",
      "title": "IaeActionOpenid4vpPresentation",
      "type": "object",
      "properties": {
        "type": {
          "enum": ["openid4vp_presentation"],
          "type": "string",
          "description": "Action type discriminator",
          "example": "openid4vp_presentation"
        },
        "label": {
          "type": "string",
          "description": "Optional label for this step (for display purposes)",
          "example": "Identity Verification"
        },
        "presentationConfigId": {
          "type": "string",
          "description": "ID of the presentation configuration to use for this step",
          "example": "pid-presentation-config"
        }
      },
      "required": ["type", "presentationConfigId"]
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/IaeActionRedirectToWeb.schema.json",
    "fileMatch": ["a://b/IaeActionRedirectToWeb*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/IaeActionRedirectToWeb.schema.json",
      "title": "IaeActionRedirectToWeb",
      "type": "object",
      "properties": {
        "type": {
          "enum": ["redirect_to_web"],
          "type": "string",
          "description": "Action type discriminator",
          "example": "redirect_to_web"
        },
        "label": {
          "type": "string",
          "description": "Optional label for this step (for display purposes)",
          "example": "Identity Verification"
        },
        "url": {
          "type": "string",
          "format": "uri",
          "description": "URL to redirect the user to for web-based interaction",
          "example": "https://example.com/verify?session={auth_session}"
        },
        "callbackUrl": {
          "type": "string",
          "format": "uri",
          "description": "URL where the external service should redirect back after completion. If not provided, the service must call back to the IAE endpoint.",
          "example": "https://issuer.example.com/{tenantId}/authorize/interactive/callback"
        },
        "description": {
          "type": "string",
          "description": "Description of what the user should do on the web page (for wallet display)",
          "example": "Please complete the identity verification form"
        }
      },
      "required": ["type", "url"]
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/EmbeddedDisclosurePolicy.schema.json",
    "fileMatch": ["a://b/EmbeddedDisclosurePolicy*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/EmbeddedDisclosurePolicy.schema.json",
      "title": "EmbeddedDisclosurePolicy",
      "type": "object",
      "properties": {
        "policy": {
          "type": "string"
        }
      },
      "required": ["policy"]
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/DisplayImage.schema.json",
    "fileMatch": ["a://b/DisplayImage*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/DisplayImage.schema.json",
      "title": "DisplayImage",
      "type": "object",
      "properties": {
        "uri": {
          "type": "string"
        }
      },
      "required": ["uri"]
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/Display.schema.json",
    "fileMatch": ["a://b/Display*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/Display.schema.json",
      "title": "Display",
      "type": "object",
      "properties": {
        "name": {
          "type": "string"
        },
        "description": {
          "type": "string"
        },
        "locale": {
          "type": "string"
        },
        "background_color": {
          "type": "string"
        },
        "text_color": {
          "type": "string"
        },
        "background_image": {
          "$ref": "./DisplayImage.schema.json"
        },
        "logo": {
          "$ref": "./DisplayImage.schema.json"
        }
      },
      "required": ["name", "description", "locale"]
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/IssuerMetadataCredentialConfig.schema.json",
    "fileMatch": ["a://b/IssuerMetadataCredentialConfig*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/IssuerMetadataCredentialConfig.schema.json",
      "title": "IssuerMetadataCredentialConfig",
      "type": "object",
      "properties": {
        "format": {
          "type": "string",
          "enum": ["mso_mdoc", "dc+sd-jwt"]
        },
        "display": {
          "type": "array",
          "items": {
            "$ref": "./Display.schema.json"
          }
        },
        "scope": {
          "type": "string"
        },
        "docType": {
          "type": "string",
          "description": "Document type for mDOC credentials (e.g., \"org.iso.18013.5.1.mDL\").\nOnly applicable when format is \"mso_mdoc\"."
        },
        "namespace": {
          "type": "string",
          "description": "Namespace for mDOC credentials (e.g., \"org.iso.18013.5.1\").\nOnly applicable when format is \"mso_mdoc\".\nUsed when claims are provided as a flat object."
        },
        "claimsByNamespace": {
          "type": "object",
          "description": "Claims organized by namespace for mDOC credentials.\nAllows specifying claims across multiple namespaces.\nOnly applicable when format is \"mso_mdoc\".\nExample:\n{\n  \"org.iso.18013.5.1\": { \"given_name\": \"John\", \"family_name\": \"Doe\" },\n  \"org.iso.18013.5.1.aamva\": { \"DHS_compliance\": \"F\" }\n}"
        }
      },
      "required": ["format", "display"]
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/SchemaResponse.schema.json",
    "fileMatch": ["a://b/SchemaResponse*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/SchemaResponse.schema.json",
      "title": "SchemaResponse",
      "type": "object",
      "properties": {
        "$schema": {
          "type": "string"
        },
        "type": {
          "type": "string"
        },
        "properties": {
          "type": "object"
        },
        "required": {
          "type": "array",
          "items": {
            "type": "string"
          }
        },
        "title": {
          "type": "string"
        },
        "description": {
          "type": "string"
        }
      },
      "required": ["$schema", "type", "properties"]
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/CredentialConfig.schema.json",
    "fileMatch": ["a://b/CredentialConfig*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/CredentialConfig.schema.json",
      "title": "CredentialConfig",
      "type": "object",
      "properties": {
        "vct": {
          "description": "VCT as a URI string (e.g., urn:eudi:pid:de:1) or as an object for EUDIPLO-hosted VCT",
          "nullable": true,
          "oneOf": [
            {
              "type": "string",
              "description": "VCT URI string"
            },
            {
              "$ref": "./VCT.schema.json"
            }
          ]
        },
        "iaeActions": {
          "type": "array",
          "nullable": true,
          "description": "List of IAE actions to execute before credential issuance",
          "example": "",
          "items": {
            "oneOf": [
              {
                "$ref": "./IaeActionOpenid4vpPresentation.schema.json"
              },
              {
                "$ref": "./IaeActionRedirectToWeb.schema.json"
              }
            ]
          }
        },
        "embeddedDisclosurePolicy": {
          "nullable": true,
          "description": "Embedded disclosure policy (discriminated union by `policy`).\nThe discriminator makes class-transformer instantiate the right subclass,\nand then class-validator runs that subclass’s rules.",
          "oneOf": [
            {
              "$ref": "./AttestationBasedPolicy.schema.json"
            },
            {
              "$ref": "./NoneTrustPolicy.schema.json"
            },
            {
              "$ref": "./AllowListPolicy.schema.json"
            },
            {
              "$ref": "./RootOfTrustPolicy.schema.json"
            }
          ],
          "allOf": [
            {
              "$ref": "./EmbeddedDisclosurePolicy.schema.json"
            }
          ]
        },
        "id": {
          "type": "string"
        },
        "description": {
          "type": "string",
          "nullable": true
        },
        "tenant": {
          "description": "The tenant that owns this object.",
          "allOf": [
            {
              "$ref": "./TenantEntity.schema.json"
            }
          ]
        },
        "config": {
          "$ref": "./IssuerMetadataCredentialConfig.schema.json"
        },
        "claims": {
          "type": "object",
          "nullable": true
        },
        "claimsWebhook": {
          "nullable": true,
          "description": "Webhook to receive claims for the issuance process.",
          "allOf": [
            {
              "$ref": "./WebhookConfig.schema.json"
            }
          ]
        },
        "notificationWebhook": {
          "nullable": true,
          "description": "Webhook to receive claims for the issuance process.",
          "allOf": [
            {
              "$ref": "./WebhookConfig.schema.json"
            }
          ]
        },
        "disclosureFrame": {
          "type": "object",
          "nullable": true
        },
        "keyBinding": {
          "type": "boolean"
        },
        "certId": {
          "type": "string",
          "description": "Reference to the certificate used for signing.\nNote: No DB-level FK constraint because CertEntity has a composite PK\n(id + tenantId) and SET NULL behavior cannot work when tenantId is\npart of this entity's own PK."
        },
        "cert": {
          "$ref": "./CertEntity.schema.json"
        },
        "statusManagement": {
          "type": "boolean"
        },
        "lifeTime": {
          "type": "number"
        },
        "schema": {
          "nullable": true,
          "allOf": [
            {
              "$ref": "./SchemaResponse.schema.json"
            }
          ]
        }
      },
      "required": ["id", "tenant", "config"]
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/CredentialConfigCreate.schema.json",
    "fileMatch": ["a://b/CredentialConfigCreate*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/CredentialConfigCreate.schema.json",
      "title": "CredentialConfigCreate",
      "type": "object",
      "properties": {
        "vct": {
          "description": "VCT as a URI string (e.g., urn:eudi:pid:de:1) or as an object for EUDIPLO-hosted VCT",
          "nullable": true,
          "oneOf": [
            {
              "type": "string",
              "description": "VCT URI string"
            },
            {
              "$ref": "./VCT.schema.json"
            }
          ]
        },
        "iaeActions": {
          "type": "array",
          "nullable": true,
          "description": "List of IAE actions to execute before credential issuance",
          "example": "",
          "items": {
            "oneOf": [
              {
                "$ref": "./IaeActionOpenid4vpPresentation.schema.json"
              },
              {
                "$ref": "./IaeActionRedirectToWeb.schema.json"
              }
            ]
          }
        },
        "embeddedDisclosurePolicy": {
          "nullable": true,
          "description": "Embedded disclosure policy (discriminated union by `policy`).\nThe discriminator makes class-transformer instantiate the right subclass,\nand then class-validator runs that subclass’s rules.",
          "oneOf": [
            {
              "$ref": "./AttestationBasedPolicy.schema.json"
            },
            {
              "$ref": "./NoneTrustPolicy.schema.json"
            },
            {
              "$ref": "./AllowListPolicy.schema.json"
            },
            {
              "$ref": "./RootOfTrustPolicy.schema.json"
            }
          ],
          "allOf": [
            {
              "$ref": "./EmbeddedDisclosurePolicy.schema.json"
            }
          ]
        },
        "id": {
          "type": "string"
        },
        "description": {
          "type": "string",
          "nullable": true
        },
        "config": {
          "$ref": "./IssuerMetadataCredentialConfig.schema.json"
        },
        "claims": {
          "type": "object",
          "nullable": true
        },
        "claimsWebhook": {
          "nullable": true,
          "description": "Webhook to receive claims for the issuance process.",
          "allOf": [
            {
              "$ref": "./WebhookConfig.schema.json"
            }
          ]
        },
        "notificationWebhook": {
          "nullable": true,
          "description": "Webhook to receive claims for the issuance process.",
          "allOf": [
            {
              "$ref": "./WebhookConfig.schema.json"
            }
          ]
        },
        "disclosureFrame": {
          "type": "object",
          "nullable": true
        },
        "keyBinding": {
          "type": "boolean"
        },
        "certId": {
          "type": "string",
          "description": "Reference to the certificate used for signing.\nNote: No DB-level FK constraint because CertEntity has a composite PK\n(id + tenantId) and SET NULL behavior cannot work when tenantId is\npart of this entity's own PK."
        },
        "statusManagement": {
          "type": "boolean"
        },
        "lifeTime": {
          "type": "number"
        },
        "schema": {
          "nullable": true,
          "allOf": [
            {
              "$ref": "./SchemaResponse.schema.json"
            }
          ]
        }
      },
      "required": ["id", "config"]
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/CredentialConfigUpdate.schema.json",
    "fileMatch": ["a://b/CredentialConfigUpdate*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/CredentialConfigUpdate.schema.json",
      "title": "CredentialConfigUpdate",
      "type": "object",
      "properties": {
        "vct": {
          "description": "VCT as a URI string (e.g., urn:eudi:pid:de:1) or as an object for EUDIPLO-hosted VCT",
          "nullable": true,
          "oneOf": [
            {
              "type": "string",
              "description": "VCT URI string"
            },
            {
              "$ref": "./VCT.schema.json"
            }
          ]
        },
        "iaeActions": {
          "type": "array",
          "nullable": true,
          "description": "List of IAE actions to execute before credential issuance",
          "example": "",
          "items": {
            "oneOf": [
              {
                "$ref": "./IaeActionOpenid4vpPresentation.schema.json"
              },
              {
                "$ref": "./IaeActionRedirectToWeb.schema.json"
              }
            ]
          }
        },
        "embeddedDisclosurePolicy": {
          "nullable": true,
          "description": "Embedded disclosure policy (discriminated union by `policy`).\nThe discriminator makes class-transformer instantiate the right subclass,\nand then class-validator runs that subclass’s rules.",
          "oneOf": [
            {
              "$ref": "./AttestationBasedPolicy.schema.json"
            },
            {
              "$ref": "./NoneTrustPolicy.schema.json"
            },
            {
              "$ref": "./AllowListPolicy.schema.json"
            },
            {
              "$ref": "./RootOfTrustPolicy.schema.json"
            }
          ],
          "allOf": [
            {
              "$ref": "./EmbeddedDisclosurePolicy.schema.json"
            }
          ]
        },
        "id": {
          "type": "string"
        },
        "description": {
          "type": "string",
          "nullable": true
        },
        "config": {
          "$ref": "./IssuerMetadataCredentialConfig.schema.json"
        },
        "claims": {
          "type": "object",
          "nullable": true
        },
        "claimsWebhook": {
          "nullable": true,
          "description": "Webhook to receive claims for the issuance process.",
          "allOf": [
            {
              "$ref": "./WebhookConfig.schema.json"
            }
          ]
        },
        "notificationWebhook": {
          "nullable": true,
          "description": "Webhook to receive claims for the issuance process.",
          "allOf": [
            {
              "$ref": "./WebhookConfig.schema.json"
            }
          ]
        },
        "disclosureFrame": {
          "type": "object",
          "nullable": true
        },
        "keyBinding": {
          "type": "boolean"
        },
        "certId": {
          "type": "string",
          "description": "Reference to the certificate used for signing.\nNote: No DB-level FK constraint because CertEntity has a composite PK\n(id + tenantId) and SET NULL behavior cannot work when tenantId is\npart of this entity's own PK."
        },
        "statusManagement": {
          "type": "boolean"
        },
        "lifeTime": {
          "type": "number"
        },
        "schema": {
          "nullable": true,
          "allOf": [
            {
              "$ref": "./SchemaResponse.schema.json"
            }
          ]
        }
      }
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/DCQL.schema.json",
    "fileMatch": ["a://b/DCQL*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/DCQL.schema.json",
      "title": "DCQL",
      "type": "object",
      "properties": {
        "credentials": {
          "type": "array",
          "items": {
            "$ref": "./CredentialQuery.schema.json"
          }
        },
        "credential_sets": {
          "type": "array",
          "items": {
            "$ref": "./CredentialSetQuery.schema.json"
          }
        }
      },
      "required": ["credentials"]
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/RegistrationCertificateRequest.schema.json",
    "fileMatch": ["a://b/RegistrationCertificateRequest*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/RegistrationCertificateRequest.schema.json",
      "title": "RegistrationCertificateRequest",
      "type": "object",
      "properties": {
        "jwt": {
          "type": "string",
          "description": "The body of the registration certificate request containing the necessary details."
        }
      },
      "required": ["jwt"]
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/PresentationAttachment.schema.json",
    "fileMatch": ["a://b/PresentationAttachment*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/PresentationAttachment.schema.json",
      "title": "PresentationAttachment",
      "type": "object",
      "properties": {
        "format": {
          "type": "string"
        },
        "data": {
          "type": "object"
        },
        "credential_ids": {
          "type": "array",
          "items": {
            "type": "string"
          }
        }
      },
      "required": ["format", "data"]
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/PresentationConfig.schema.json",
    "fileMatch": ["a://b/PresentationConfig*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/PresentationConfig.schema.json",
      "title": "PresentationConfig",
      "type": "object",
      "properties": {
        "id": {
          "type": "string",
          "description": "Unique identifier for the VP request."
        },
        "tenant": {
          "description": "The tenant that owns this object.",
          "allOf": [
            {
              "$ref": "./TenantEntity.schema.json"
            }
          ]
        },
        "description": {
          "type": "string",
          "nullable": true,
          "description": "Description of the presentation configuration."
        },
        "lifeTime": {
          "type": "number",
          "description": "Lifetime how long the presentation request is valid after creation, in seconds."
        },
        "dcql_query": {
          "description": "The DCQL query to be used for the VP request.",
          "allOf": [
            {
              "$ref": "./DCQL.schema.json"
            }
          ]
        },
        "transaction_data": {
          "type": "array",
          "items": {
            "$ref": "./TransactionData.schema.json"
          }
        },
        "registrationCert": {
          "nullable": true,
          "description": "The registration certificate request containing the necessary details.",
          "allOf": [
            {
              "$ref": "./RegistrationCertificateRequest.schema.json"
            }
          ]
        },
        "webhook": {
          "nullable": true,
          "description": "Optional webhook URL to receive the response.",
          "allOf": [
            {
              "$ref": "./WebhookConfig.schema.json"
            }
          ]
        },
        "createdAt": {
          "format": "date-time",
          "type": "string",
          "description": "The timestamp when the VP request was created."
        },
        "updatedAt": {
          "format": "date-time",
          "type": "string",
          "description": "The timestamp when the VP request was last updated."
        },
        "attached": {
          "nullable": true,
          "description": "Attestation that should be attached",
          "type": "array",
          "items": {
            "$ref": "./PresentationAttachment.schema.json"
          }
        },
        "redirectUri": {
          "type": "string",
          "nullable": true,
          "description": "Redirect URI to which the user-agent should be redirected after the presentation is completed.\nYou can use the `{sessionId}` placeholder in the URI, which will be replaced with the actual session ID.",
          "example": "https://example.com/callback?session={sessionId}"
        },
        "accessCertId": {
          "type": "string",
          "nullable": true,
          "description": "Optional ID of the access certificate to use for signing the presentation request.\nIf not provided, the default access certificate for the tenant will be used.\n\nNote: This is intentionally NOT a TypeORM relationship because CertEntity uses\na composite primary key (id + tenantId), and SQLite cannot create foreign keys\nthat reference only part of a composite primary key. The relationship is handled\nat the application level in the service layer."
        }
      },
      "required": ["id", "tenant", "dcql_query", "createdAt", "updatedAt"]
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/PresentationConfigCreateDto.schema.json",
    "fileMatch": ["a://b/PresentationConfigCreateDto*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/PresentationConfigCreateDto.schema.json",
      "title": "PresentationConfigCreateDto",
      "type": "object",
      "properties": {
        "id": {
          "type": "string",
          "description": "Unique identifier for the VP request."
        },
        "description": {
          "type": "string",
          "nullable": true,
          "description": "Description of the presentation configuration."
        },
        "lifeTime": {
          "type": "number",
          "description": "Lifetime how long the presentation request is valid after creation, in seconds."
        },
        "dcql_query": {
          "description": "The DCQL query to be used for the VP request.",
          "allOf": [
            {
              "$ref": "./DCQL.schema.json"
            }
          ]
        },
        "transaction_data": {
          "type": "array",
          "items": {
            "$ref": "./TransactionData.schema.json"
          }
        },
        "registrationCert": {
          "nullable": true,
          "description": "The registration certificate request containing the necessary details.",
          "allOf": [
            {
              "$ref": "./RegistrationCertificateRequest.schema.json"
            }
          ]
        },
        "webhook": {
          "nullable": true,
          "description": "Optional webhook URL to receive the response.",
          "allOf": [
            {
              "$ref": "./WebhookConfig.schema.json"
            }
          ]
        },
        "attached": {
          "nullable": true,
          "description": "Attestation that should be attached",
          "type": "array",
          "items": {
            "$ref": "./PresentationAttachment.schema.json"
          }
        },
        "redirectUri": {
          "type": "string",
          "nullable": true,
          "description": "Redirect URI to which the user-agent should be redirected after the presentation is completed.\nYou can use the `{sessionId}` placeholder in the URI, which will be replaced with the actual session ID.",
          "example": "https://example.com/callback?session={sessionId}"
        },
        "accessCertId": {
          "type": "string",
          "nullable": true,
          "description": "Optional ID of the access certificate to use for signing the presentation request.\nIf not provided, the default access certificate for the tenant will be used.\n\nNote: This is intentionally NOT a TypeORM relationship because CertEntity uses\na composite primary key (id + tenantId), and SQLite cannot create foreign keys\nthat reference only part of a composite primary key. The relationship is handled\nat the application level in the service layer."
        }
      },
      "required": ["id", "dcql_query"]
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/PresentationConfigUpdateDto.schema.json",
    "fileMatch": ["a://b/PresentationConfigUpdateDto*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/PresentationConfigUpdateDto.schema.json",
      "title": "PresentationConfigUpdateDto",
      "type": "object",
      "properties": {
        "id": {
          "type": "string",
          "description": "Unique identifier for the VP request."
        },
        "description": {
          "type": "string",
          "nullable": true,
          "description": "Description of the presentation configuration."
        },
        "lifeTime": {
          "type": "number",
          "description": "Lifetime how long the presentation request is valid after creation, in seconds."
        },
        "dcql_query": {
          "description": "The DCQL query to be used for the VP request.",
          "allOf": [
            {
              "$ref": "./DCQL.schema.json"
            }
          ]
        },
        "transaction_data": {
          "type": "array",
          "items": {
            "$ref": "./TransactionData.schema.json"
          }
        },
        "registrationCert": {
          "nullable": true,
          "description": "The registration certificate request containing the necessary details.",
          "allOf": [
            {
              "$ref": "./RegistrationCertificateRequest.schema.json"
            }
          ]
        },
        "webhook": {
          "nullable": true,
          "description": "Optional webhook URL to receive the response.",
          "allOf": [
            {
              "$ref": "./WebhookConfig.schema.json"
            }
          ]
        },
        "attached": {
          "nullable": true,
          "description": "Attestation that should be attached",
          "type": "array",
          "items": {
            "$ref": "./PresentationAttachment.schema.json"
          }
        },
        "redirectUri": {
          "type": "string",
          "nullable": true,
          "description": "Redirect URI to which the user-agent should be redirected after the presentation is completed.\nYou can use the `{sessionId}` placeholder in the URI, which will be replaced with the actual session ID.",
          "example": "https://example.com/callback?session={sessionId}"
        },
        "accessCertId": {
          "type": "string",
          "nullable": true,
          "description": "Optional ID of the access certificate to use for signing the presentation request.\nIf not provided, the default access certificate for the tenant will be used.\n\nNote: This is intentionally NOT a TypeORM relationship because CertEntity uses\na composite primary key (id + tenantId), and SQLite cannot create foreign keys\nthat reference only part of a composite primary key. The relationship is handled\nat the application level in the service layer."
        }
      }
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/DeferredCredentialRequestDto.schema.json",
    "fileMatch": ["a://b/DeferredCredentialRequestDto*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/DeferredCredentialRequestDto.schema.json",
      "title": "DeferredCredentialRequestDto",
      "type": "object",
      "properties": {
        "transaction_id": {
          "type": "string",
          "description": "The transaction identifier previously returned by the Credential Endpoint",
          "example": "8xLOxBtZp8"
        }
      },
      "required": ["transaction_id"]
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/NotificationRequestDto.schema.json",
    "fileMatch": ["a://b/NotificationRequestDto*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/NotificationRequestDto.schema.json",
      "title": "NotificationRequestDto",
      "type": "object",
      "properties": {
        "notification_id": {
          "type": "string"
        },
        "event": {
          "type": "object"
        }
      },
      "required": ["notification_id", "event"]
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/ParResponseDto.schema.json",
    "fileMatch": ["a://b/ParResponseDto*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/ParResponseDto.schema.json",
      "title": "ParResponseDto",
      "type": "object",
      "properties": {
        "request_uri": {
          "type": "string",
          "description": "The request URI for the Pushed Authorization Request."
        },
        "expires_in": {
          "type": "number",
          "description": "The expiration time for the request URI in seconds."
        }
      },
      "required": ["request_uri", "expires_in"]
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/InteractiveAuthorizationRequestDto.schema.json",
    "fileMatch": ["a://b/InteractiveAuthorizationRequestDto*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/InteractiveAuthorizationRequestDto.schema.json",
      "title": "InteractiveAuthorizationRequestDto",
      "type": "object",
      "properties": {
        "response_type": {
          "type": "string",
          "description": "Response type (for initial request)"
        },
        "client_id": {
          "type": "string",
          "description": "Client identifier (for initial request)"
        },
        "interaction_types_supported": {
          "type": "string",
          "description": "Comma-separated list of supported interaction types (for initial request)"
        },
        "redirect_uri": {
          "type": "string",
          "description": "Redirect URI (for initial request)"
        },
        "scope": {
          "type": "string",
          "description": "OAuth scope"
        },
        "code_challenge": {
          "type": "string",
          "description": "PKCE code challenge"
        },
        "code_challenge_method": {
          "type": "string",
          "description": "PKCE code challenge method"
        },
        "authorization_details": {
          "type": "object",
          "description": "Authorization details"
        },
        "state": {
          "type": "string",
          "description": "State parameter"
        },
        "issuer_state": {
          "type": "string",
          "description": "Issuer state from credential offer"
        },
        "auth_session": {
          "type": "string",
          "description": "Auth session identifier (for follow-up request)"
        },
        "openid4vp_response": {
          "type": "string",
          "description": "OpenID4VP response (for follow-up request)"
        },
        "code_verifier": {
          "type": "string",
          "description": "PKCE code verifier (for follow-up request)"
        },
        "request": {
          "type": "string",
          "description": "JAR request JWT (by value)"
        },
        "request_uri": {
          "type": "string",
          "description": "JAR request URI (by reference)"
        }
      }
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/InteractiveAuthorizationCodeResponseDto.schema.json",
    "fileMatch": ["a://b/InteractiveAuthorizationCodeResponseDto*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/InteractiveAuthorizationCodeResponseDto.schema.json",
      "title": "InteractiveAuthorizationCodeResponseDto",
      "type": "object",
      "properties": {
        "status": {
          "type": "string",
          "description": "Response status",
          "example": "ok"
        },
        "code": {
          "type": "string",
          "description": "Authorization code",
          "example": "auth-code-123"
        }
      },
      "required": ["status", "code"]
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/InteractiveAuthorizationErrorResponseDto.schema.json",
    "fileMatch": ["a://b/InteractiveAuthorizationErrorResponseDto*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/InteractiveAuthorizationErrorResponseDto.schema.json",
      "title": "InteractiveAuthorizationErrorResponseDto",
      "type": "object",
      "properties": {
        "error": {
          "type": "string",
          "description": "OAuth error code",
          "example": "invalid_request"
        },
        "error_description": {
          "type": "string",
          "description": "Human-readable error description",
          "example": "Missing required parameter: interaction_types_supported"
        }
      },
      "required": ["error"]
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/ChainedAsParRequestDto.schema.json",
    "fileMatch": ["a://b/ChainedAsParRequestDto*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/ChainedAsParRequestDto.schema.json",
      "title": "ChainedAsParRequestDto",
      "type": "object",
      "properties": {
        "response_type": {
          "type": "string",
          "description": "OAuth response type (must be 'code')",
          "example": "code"
        },
        "client_id": {
          "type": "string",
          "description": "Client identifier (wallet identifier)",
          "example": "https://wallet.example.com"
        },
        "redirect_uri": {
          "type": "string",
          "description": "URI to redirect the wallet after authorization",
          "example": "https://wallet.example.com/callback"
        },
        "code_challenge": {
          "type": "string",
          "description": "PKCE code challenge"
        },
        "code_challenge_method": {
          "type": "string",
          "description": "PKCE code challenge method (e.g., S256)",
          "example": "S256"
        },
        "state": {
          "type": "string",
          "description": "State parameter (returned in redirect)"
        },
        "scope": {
          "type": "string",
          "description": "Scope requested",
          "example": "openid credential"
        },
        "issuer_state": {
          "type": "string",
          "description": "Issuer state from credential offer"
        },
        "authorization_details": {
          "description": "Authorization details (JSON array)",
          "type": "array",
          "items": {
            "type": "object"
          }
        }
      },
      "required": ["response_type", "client_id", "redirect_uri"]
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/ChainedAsParResponseDto.schema.json",
    "fileMatch": ["a://b/ChainedAsParResponseDto*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/ChainedAsParResponseDto.schema.json",
      "title": "ChainedAsParResponseDto",
      "type": "object",
      "properties": {
        "request_uri": {
          "type": "string",
          "description": "The request URI to use at the authorization endpoint",
          "example": "urn:ietf:params:oauth:request_uri:abc123"
        },
        "expires_in": {
          "type": "number",
          "description": "The lifetime of the request URI in seconds",
          "example": 600
        }
      },
      "required": ["request_uri", "expires_in"]
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/ChainedAsErrorResponseDto.schema.json",
    "fileMatch": ["a://b/ChainedAsErrorResponseDto*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/ChainedAsErrorResponseDto.schema.json",
      "title": "ChainedAsErrorResponseDto",
      "type": "object",
      "properties": {
        "error": {
          "type": "string",
          "description": "Error code",
          "example": "invalid_request"
        },
        "error_description": {
          "type": "string",
          "description": "Human-readable error description"
        }
      },
      "required": ["error"]
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/ChainedAsTokenRequestDto.schema.json",
    "fileMatch": ["a://b/ChainedAsTokenRequestDto*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/ChainedAsTokenRequestDto.schema.json",
      "title": "ChainedAsTokenRequestDto",
      "type": "object",
      "properties": {
        "grant_type": {
          "type": "string",
          "description": "Grant type (must be 'authorization_code')",
          "example": "authorization_code"
        },
        "code": {
          "type": "string",
          "description": "Authorization code received in the callback"
        },
        "client_id": {
          "type": "string",
          "description": "Client identifier"
        },
        "redirect_uri": {
          "type": "string",
          "description": "Redirect URI (must match the one used in PAR)"
        },
        "code_verifier": {
          "type": "string",
          "description": "PKCE code verifier"
        }
      },
      "required": ["grant_type", "code"]
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/ChainedAsTokenResponseDto.schema.json",
    "fileMatch": ["a://b/ChainedAsTokenResponseDto*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/ChainedAsTokenResponseDto.schema.json",
      "title": "ChainedAsTokenResponseDto",
      "type": "object",
      "properties": {
        "access_token": {
          "type": "string",
          "description": "The access token"
        },
        "token_type": {
          "type": "string",
          "description": "Token type (Bearer or DPoP)",
          "example": "DPoP"
        },
        "expires_in": {
          "type": "number",
          "description": "Token lifetime in seconds",
          "example": 3600
        },
        "scope": {
          "type": "string",
          "description": "Scope granted"
        },
        "authorization_details": {
          "description": "Authorized credential configurations",
          "type": "array",
          "items": {
            "type": "object"
          }
        },
        "c_nonce": {
          "type": "string",
          "description": "C_NONCE for credential request"
        },
        "c_nonce_expires_in": {
          "type": "number",
          "description": "C_NONCE lifetime in seconds"
        }
      },
      "required": ["access_token", "token_type", "expires_in"]
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/OfferResponse.schema.json",
    "fileMatch": ["a://b/OfferResponse*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/OfferResponse.schema.json",
      "title": "OfferResponse",
      "type": "object",
      "properties": {
        "uri": {
          "type": "string"
        },
        "crossDeviceUri": {
          "type": "string",
          "description": "URI for cross-device flows (no redirect after completion)"
        },
        "session": {
          "type": "string"
        }
      },
      "required": ["uri", "session"]
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/CompleteDeferredDto.schema.json",
    "fileMatch": ["a://b/CompleteDeferredDto*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/CompleteDeferredDto.schema.json",
      "title": "CompleteDeferredDto",
      "type": "object",
      "properties": {
        "claims": {
          "type": "object",
          "description": "Claims to include in the credential. The structure should match the credential configuration's expected claims.",
          "example": {
            "given_name": "John",
            "family_name": "Doe",
            "birthdate": "1990-01-15"
          }
        }
      },
      "required": ["claims"]
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/DeferredOperationResponse.schema.json",
    "fileMatch": ["a://b/DeferredOperationResponse*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/DeferredOperationResponse.schema.json",
      "title": "DeferredOperationResponse",
      "type": "object",
      "properties": {
        "transactionId": {
          "type": "string",
          "description": "The transaction ID"
        },
        "status": {
          "description": "The new status of the transaction",
          "enum": ["pending", "ready", "retrieved", "expired", "failed"],
          "type": "string"
        },
        "message": {
          "type": "string",
          "description": "Optional message"
        }
      },
      "required": ["transactionId", "status"]
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/FailDeferredDto.schema.json",
    "fileMatch": ["a://b/FailDeferredDto*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/FailDeferredDto.schema.json",
      "title": "FailDeferredDto",
      "type": "object",
      "properties": {
        "error": {
          "type": "string",
          "description": "Optional error message explaining why the issuance failed",
          "example": "Identity verification failed"
        }
      }
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/EC_Public.schema.json",
    "fileMatch": ["a://b/EC_Public*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/EC_Public.schema.json",
      "title": "EC_Public",
      "type": "object",
      "properties": {
        "kty": {
          "type": "string",
          "description": "The key type, which is always 'EC' for Elliptic Curve keys."
        },
        "crv": {
          "type": "string",
          "description": "The algorithm intended for use with the key, such as 'ES256'."
        },
        "x": {
          "type": "string",
          "description": "The x coordinate of the EC public key."
        },
        "y": {
          "type": "string",
          "description": "The y coordinate of the EC public key."
        }
      },
      "required": ["kty", "crv", "x", "y"]
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/JwksResponseDto.schema.json",
    "fileMatch": ["a://b/JwksResponseDto*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/JwksResponseDto.schema.json",
      "title": "JwksResponseDto",
      "type": "object",
      "properties": {
        "keys": {
          "description": "An array of EC public keys in JWK format.",
          "type": "array",
          "items": {
            "$ref": "./EC_Public.schema.json"
          }
        }
      },
      "required": ["keys"]
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/AuthorizationResponse.schema.json",
    "fileMatch": ["a://b/AuthorizationResponse*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/AuthorizationResponse.schema.json",
      "title": "AuthorizationResponse",
      "type": "object",
      "properties": {
        "response": {
          "type": "string",
          "description": "The response string containing the authorization details."
        },
        "sendResponse": {
          "type": "boolean",
          "description": "When set to true, the authorization response will be sent to the client."
        }
      },
      "required": ["response"]
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/RegistrarConfigEntity.schema.json",
    "fileMatch": ["a://b/RegistrarConfigEntity*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/RegistrarConfigEntity.schema.json",
      "title": "RegistrarConfigEntity",
      "type": "object",
      "properties": {
        "registrarUrl": {
          "type": "string",
          "description": "The base URL of the registrar API",
          "format": "uri",
          "example": "https://sandbox.eudi-wallet.org/api"
        },
        "oidcUrl": {
          "type": "string",
          "description": "The OIDC issuer URL for authentication (e.g., Keycloak realm URL)",
          "format": "uri",
          "example": "https://auth.example.com/realms/my-realm"
        },
        "clientId": {
          "type": "string",
          "description": "The OIDC client ID for the registrar",
          "example": "registrar-client"
        },
        "clientSecret": {
          "type": "string",
          "description": "The OIDC client secret (optional, for confidential clients)"
        },
        "username": {
          "type": "string",
          "description": "The username for OIDC login",
          "example": "admin@example.com"
        },
        "password": {
          "type": "string",
          "description": "The password for OIDC login (stored in plaintext)"
        },
        "tenantId": {
          "type": "string",
          "description": "The tenant ID this configuration belongs to."
        },
        "tenant": {
          "description": "The tenant that owns this configuration.",
          "allOf": [
            {
              "$ref": "./TenantEntity.schema.json"
            }
          ]
        }
      },
      "required": [
        "registrarUrl",
        "oidcUrl",
        "clientId",
        "username",
        "password",
        "tenantId",
        "tenant"
      ]
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/CreateRegistrarConfigDto.schema.json",
    "fileMatch": ["a://b/CreateRegistrarConfigDto*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/CreateRegistrarConfigDto.schema.json",
      "title": "CreateRegistrarConfigDto",
      "type": "object",
      "properties": {
        "registrarUrl": {
          "type": "string",
          "description": "The base URL of the registrar API",
          "format": "uri",
          "example": "https://sandbox.eudi-wallet.org/api"
        },
        "oidcUrl": {
          "type": "string",
          "description": "The OIDC issuer URL for authentication (e.g., Keycloak realm URL)",
          "format": "uri",
          "example": "https://auth.example.com/realms/my-realm"
        },
        "clientId": {
          "type": "string",
          "description": "The OIDC client ID for the registrar",
          "example": "registrar-client"
        },
        "clientSecret": {
          "type": "string",
          "description": "The OIDC client secret (optional, for confidential clients)"
        },
        "username": {
          "type": "string",
          "description": "The username for OIDC login",
          "example": "admin@example.com"
        },
        "password": {
          "type": "string",
          "description": "The password for OIDC login (stored in plaintext)"
        }
      },
      "required": ["registrarUrl", "oidcUrl", "clientId", "username", "password"]
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/UpdateRegistrarConfigDto.schema.json",
    "fileMatch": ["a://b/UpdateRegistrarConfigDto*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/UpdateRegistrarConfigDto.schema.json",
      "title": "UpdateRegistrarConfigDto",
      "type": "object",
      "properties": {
        "registrarUrl": {
          "type": "string",
          "description": "The base URL of the registrar API",
          "format": "uri",
          "example": "https://sandbox.eudi-wallet.org/api"
        },
        "oidcUrl": {
          "type": "string",
          "description": "The OIDC issuer URL for authentication (e.g., Keycloak realm URL)",
          "format": "uri",
          "example": "https://auth.example.com/realms/my-realm"
        },
        "clientId": {
          "type": "string",
          "description": "The OIDC client ID for the registrar",
          "example": "registrar-client"
        },
        "clientSecret": {
          "type": "string",
          "description": "The OIDC client secret (optional, for confidential clients)"
        },
        "username": {
          "type": "string",
          "description": "The username for OIDC login",
          "example": "admin@example.com"
        },
        "password": {
          "type": "string",
          "description": "The password for OIDC login (stored in plaintext)"
        }
      }
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/CreateAccessCertificateDto.schema.json",
    "fileMatch": ["a://b/CreateAccessCertificateDto*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/CreateAccessCertificateDto.schema.json",
      "title": "CreateAccessCertificateDto",
      "type": "object",
      "properties": {
        "keyId": {
          "type": "string",
          "description": "The ID of the key to create an access certificate for",
          "example": "my-signing-key"
        }
      },
      "required": ["keyId"]
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/TrustListCreateDto.schema.json",
    "fileMatch": ["a://b/TrustListCreateDto*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/TrustListCreateDto.schema.json",
      "title": "TrustListCreateDto",
      "type": "object",
      "properties": {
        "id": {
          "type": "string"
        },
        "certId": {
          "type": "string"
        },
        "entities": {
          "type": "array",
          "items": {
            "type": "object"
          }
        },
        "description": {
          "type": "string"
        },
        "data": {
          "type": "object",
          "description": "The full trust list JSON (generated LoTE structure)"
        }
      },
      "required": ["entities"]
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/TrustList.schema.json",
    "fileMatch": ["a://b/TrustList*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/TrustList.schema.json",
      "title": "TrustList",
      "type": "object",
      "properties": {
        "id": {
          "type": "string",
          "description": "Unique identifier for the trust list"
        },
        "description": {
          "type": "string"
        },
        "tenantId": {
          "type": "string",
          "description": "The tenant ID for which the VP request is made."
        },
        "tenant": {
          "description": "The tenant that owns this object.",
          "allOf": [
            {
              "$ref": "./TenantEntity.schema.json"
            }
          ]
        },
        "certId": {
          "type": "string"
        },
        "cert": {
          "$ref": "./CertEntity.schema.json"
        },
        "data": {
          "type": "object",
          "description": "The full trust list JSON (generated LoTE structure)"
        },
        "entityConfig": {
          "description": "The original entity configuration used to create this trust list.\nStored for round-tripping when editing.",
          "type": "array",
          "items": {
            "type": "object"
          }
        },
        "sequenceNumber": {
          "type": "number",
          "description": "The sequence number for versioning (incremented on updates)"
        },
        "jwt": {
          "type": "string",
          "description": "The signed JWT representation of this trust list"
        },
        "createdAt": {
          "format": "date-time",
          "type": "string"
        },
        "updatedAt": {
          "format": "date-time",
          "type": "string"
        }
      },
      "required": [
        "id",
        "tenantId",
        "tenant",
        "certId",
        "cert",
        "sequenceNumber",
        "jwt",
        "createdAt",
        "updatedAt"
      ]
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/TrustListVersion.schema.json",
    "fileMatch": ["a://b/TrustListVersion*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/TrustListVersion.schema.json",
      "title": "TrustListVersion",
      "type": "object",
      "properties": {
        "id": {
          "type": "string"
        },
        "trustListId": {
          "type": "string"
        },
        "trustList": {
          "$ref": "./TrustList.schema.json"
        },
        "tenantId": {
          "type": "string"
        },
        "sequenceNumber": {
          "type": "number",
          "description": "The sequence number at the time this version was created"
        },
        "data": {
          "type": "object",
          "description": "The full trust list JSON at this version"
        },
        "entityConfig": {
          "type": "object",
          "description": "The entity configuration at this version"
        },
        "jwt": {
          "type": "string",
          "description": "The signed JWT at this version"
        },
        "createdAt": {
          "format": "date-time",
          "type": "string"
        }
      },
      "required": [
        "id",
        "trustListId",
        "trustList",
        "tenantId",
        "sequenceNumber",
        "data",
        "jwt",
        "createdAt"
      ]
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/PresentationRequest.schema.json",
    "fileMatch": ["a://b/PresentationRequest*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/PresentationRequest.schema.json",
      "title": "PresentationRequest",
      "type": "object",
      "properties": {
        "response_type": {
          "type": "string",
          "description": "The type of response expected from the presentation request.",
          "enum": ["uri", "dc-api"]
        },
        "requestId": {
          "type": "string",
          "description": "Identifier of the presentation configuration"
        },
        "webhook": {
          "description": "Webhook configuration to receive the response.\nIf not provided, the configured webhook from the configuration will be used.",
          "allOf": [
            {
              "$ref": "./WebhookConfig.schema.json"
            }
          ]
        },
        "redirectUri": {
          "type": "string",
          "description": "Optional redirect URI to which the user-agent should be redirected after the presentation is completed.\nYou can use the `{sessionId}` placeholder in the URI, which will be replaced with the actual session ID.",
          "example": "https://example.com/callback?session={sessionId}"
        },
        "transaction_data": {
          "description": "Optional transaction data to include in the OID4VP request.\nIf provided, this will override the transaction_data from the presentation configuration.",
          "type": "array",
          "items": {
            "$ref": "./TransactionData.schema.json"
          }
        }
      },
      "required": ["response_type", "requestId"]
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/FileUploadDto.schema.json",
    "fileMatch": ["a://b/FileUploadDto*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/FileUploadDto.schema.json",
      "title": "FileUploadDto",
      "type": "object",
      "properties": {
        "file": {
          "type": "string",
          "format": "binary"
        }
      },
      "required": ["file"]
    }
  }
]
